import { NO_MATCH, NEGATIVE_MATCH, POSITIVE_MATCH, DEFAULT_MATCH } from "./types";

import type { NodeConditionOptions } from "./types";
import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

export function checkDecorators(
  nodeCondition: NodeCondition,
  node: NodeModel,
  { skipDecoratorsCondition }: NodeConditionOptions,
): number {
  if (skipDecoratorsCondition) {
    return NO_MATCH;
  }

  if (!nodeCondition.hasDecorators) {
    return NO_MATCH;
  }

  let decoratorNode: NodeModel | undefined = node;

  if ("symbolNode" in node) {
    decoratorNode = node.symbolNode;
  }

  if (decoratorNode && "decorators" in decoratorNode && decoratorNode.decorators.length > 0) {
    if (decoratorNode.decorators.some((d) => nodeCondition.hasDecorators?.includes(d.name))) {
      return POSITIVE_MATCH;
    }
    if (
      decoratorNode.decorators.some((d) => nodeCondition.hasDecorators?.includes(`not:${d.name}`))
    ) {
      return NEGATIVE_MATCH;
    }

    const hasOnlyNegativeConditions =
      nodeCondition.hasDecorators.length > 0 &&
      nodeCondition.hasDecorators.every((d) => d.startsWith("not:"));
    return hasOnlyNegativeConditions ? DEFAULT_MATCH : NO_MATCH;
  }

  return NO_MATCH;
}
